module.exports = __webpack_public_path__ + "static/img/arrow-right-grey.2bbef04.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/arrow-right-grey.png
// module id = mnUN
// module chunks = 1